import * as React from "react";
import { observer } from "mobx-react";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkEmptyState } from "uitk-react-empty-state";
import { locKeys } from "components/flexComponents/WizardPackagePWA/l10n.ts";
import { LOBState, PackageWizardState } from "src/stores/wizard/state";

export interface PackageErrorStateProps {
  lobsMissing: number;
  packageWizardState: PackageWizardState;
  lobState: LOBState;
}

const { lobErrorHeadingsMap, lobErrorBodyMap } = locKeys;

export const PackageErrorState: React.FunctionComponent<PackageErrorStateProps> = observer(
  ({ lobsMissing, packageWizardState, lobState }) => {
    const { formatText } = useLocalization();
    const heading = formatText(lobErrorHeadingsMap[lobsMissing]);
    let body = formatText(lobErrorBodyMap[lobsMissing]);
    const { updateInvalidFormsState } = packageWizardState;

    body = lobsMissing === 99 ? formatText(lobState.config.heading.lobNotSupported) : body;

    updateInvalidFormsState();

    return (
      <UitkLayoutGridItem colSpan="all">
        <UitkEmptyState icon="search" heading={heading} body={body} headingLevel="h2" />
      </UitkLayoutGridItem>
    );
  }
);
